import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
      {/* Header Section */}
      <header className="bg-green-700 text-white py-8">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold">Privacy Policy</h1>
          <p className="mt-2 text-xl">
            PreciseDraft by Documore LLC – Global Privacy Policy
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-10">
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">1. Introduction</h2>
          <p>
            At PreciseDraft, a brand of Documore LLC, we take your privacy seriously.
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information
            when you access our website and services. Our policy applies globally — across the Americas, Europe, Asia, Africa, and Oceania.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">2. Information We Collect</h2>
          <p>
            We collect personal data such as your name, contact details, and usage information when you interact with our site.
            This includes information collected through cookies, web beacons, and other tracking technologies.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">3. How We Use Your Information</h2>
          <p>
            We use your information to provide and improve our services, process transactions, personalize your experience,
            communicate with you, and comply with legal obligations. We may also use your data for marketing purposes,
            tailored to your preferences and relevant to your region.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">4. Cookies and Tracking Technologies</h2>
          <p>
            Our website uses cookies and similar tracking technologies to enhance user experience, analyze trends,
            and gather demographic information. You can manage your cookie preferences through your browser settings.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">5. Disclosure of Your Information</h2>
          <p>
            We may share your information with third-party service providers, business partners, and governmental authorities
            as required by law. We only disclose your data when necessary to protect our rights or comply with legal obligations.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">6. Security of Your Data</h2>
          <p>
            We implement robust technical and organizational measures designed to secure your information against
            unauthorized access, alteration, disclosure, or destruction. However, please be aware that no method of
            transmission over the Internet or storage system is completely secure.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">7. International Data Transfers</h2>
          <p>
            Given our global reach, your data may be transferred to, stored, and processed in countries outside of your own.
            When this occurs, we ensure that appropriate safeguards are in place in accordance with applicable laws and regulations,
            such as the GDPR for European users.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">8. Your Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, such as the right to access,
            correct, delete, or restrict its use. To exercise these rights, please contact us using the details provided in Section 10.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">9. Compliance with Global Regulations</h2>
          <p>
            We strive to comply with privacy and data protection laws applicable in all regions where we operate,
            including laws in the United States, Europe (GDPR), Asia, Africa, and Oceania. This Policy is regularly updated
            to reflect changes in legal requirements and our practices.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">10. Changes to This Privacy Policy</h2>
          <p>
            We reserve the right to modify this Privacy Policy at any time. Any changes will be posted on this page with an updated effective date.
            Your continued use of our services following any such changes constitutes your acceptance of the new terms.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">11. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at{" "}
            <a href="mailto:support@precisedraft.ai" className="text-green-600 underline">
              support@precisedraft.ai
            </a>.
          </p>
        </section>
      </main>

      {/* Footer Section */}
      <footer className="bg-gray-800 text-white py-4">
        <div className="container mx-auto px-4 text-center">
          <p>&copy; {new Date().getFullYear()} Documore LLC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
